import { Cookie } from "@modules/util/Cookie.ts"

export default async function addEventListenersForStarsTermsOfUse() {
    if (!userData.isLoggedIn) {
        return
    }

    if (!userData.isAgeVerified) {
        return
    }

    if (userData.starsClientAuthenticated) {
        return
    }

    if (SiteInfo.ladiesStarsAuthenticateUrl === "" || SiteInfo.ladiesStarsAuthenticateUrl.length === 0) {
        return
    }

    if (!globalThis.__addEventListenersForStarsTermsOfUseExecuted) {
        // make this shit only once
        globalThis.__addEventListenersForStarsTermsOfUseExecuted = true

        if (window.location.pathname === "/stars/deine-posts") {
            __gotoStarsAuthenticationPage(null)
            return
        }

        if (window.location.pathname === "/stars/deine-stars") {
            __gotoStarsAuthenticationPage(null)
            return
        }

        __redirectIfStarPostsVisibleWithoutLock()
        __registerStarsInteractionEvents()
    }

    function __registerStarsInteractionEvents() {
        let elements: any[] = []
        let newElements = document.querySelectorAll('button[data-target="#subscriptionModalBuyButtons"]')
        if (newElements.length > 0) {
            elements = [...elements, ...newElements]
        }

        newElements = document.querySelectorAll("#stars-post-container")
        if (newElements.length > 0) {
            elements = [...elements, ...newElements]
        }

        newElements = document.querySelectorAll("#stars-post-footer")
        if (newElements.length > 0) {
            elements = [...elements, ...newElements]
        }

        if (elements.length > 0) {
            for (const element of elements) {
                element.removeEventListener("click", __gotoStarsAuthenticationPage)
                element.addEventListener("click", __gotoStarsAuthenticationPage)
            }
        }
    }

    function __redirectIfStarPostsVisibleWithoutLock() {
        setTimeout(() => {
            const container = document.querySelector("#stars-post-container .stars-post")
            if (!container) {
                return
            }

            const hasLockOverlay = container.querySelector(".lock-overlay-background") !== null

            if (!hasLockOverlay) {
                __gotoStarsAuthenticationPage(null)
                return
            }
        }, 3000)
    }

    function __gotoStarsAuthenticationPage(event: Event | null) {
        if (event) {
            event.stopImmediatePropagation()
            event.stopPropagation()
            event.preventDefault()
        }

        let redirectTo = SiteInfo.ladiesStarsAuthenticateUrl
        redirectTo = redirectTo.replace(
            "_REPLACE_REDIRECT_URI_",
            encodeURIComponent("https://" + window.location.host + "/stars-auth-callback"),
        )

        const starsAuthOriginUrlCookie = new Cookie("stars-auth-origin-url", {
            path: "/",
            domain: SiteInfo.cookieDomain,
            expires: new Date(Date.now() + 1000 * 60 * 5).toUTCString(),
        })
        starsAuthOriginUrlCookie.value = window.location.href

        window.location.href = redirectTo
    }
}
